import Vue from 'vue'
import Vuex from 'vuex'

import order from './modules/Order'
import project from './modules/Project'
import prompt from './modules/Prompt'
import talent from './modules/Talent'
import tag from './modules/Tag'
import user from './modules/User'


Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        activeProject: null,
        session_key: null,
        iframe: false,
        playerPlaying: null,
        calculating: false,
        menuOpen: false,

        pricing: {
            words_included: 0,
            price_per_prompt: 0,
            extra_words_fee: 0,
            record_fee: 0,
            type: 'prompt',
            record_fee_threshold: 0
        }
  },
  mutations: {
    setIframe (state) {
        state.iframe = true
        localStorage.setItem('iframe', true)
    },
    setActiveProject (state, projectId) {
        state.activeProject = projectId
        localStorage.setItem('activeProject', state.activeProject)
    },
    setSessionKey (state, sessionKey) {
        state.session_key = sessionKey
    },
    setPlayerPlaying (state, playing) {
        state.playerPlaying = playing
    },
    setCalculate (state, calculating) {
        state.calculating = calculating
    },
    toggleMenu (state) {
        state.menuOpen = !state.menuOpen
    },

    setPricing (state, pricePack) {
        state.pricing.words_included = pricePack.words_included
        state.pricing.price_per_prompt = parseFloat(pricePack.price)
        state.pricing.extra_words_price = pricePack.extra_words_price ? parseFloat(pricePack.extra_words_price) : parseFloat(pricePack.overage_price);
        state.pricing.record_fee = (pricePack.frequency == 'prompt') ? parseFloat(pricePack.record_fee) : null
        state.pricing.record_fee_threshold = parseInt(pricePack.record_fee_threshold)
        state.pricing.type = pricePack.frequency
    }
  },
  getters: {

  },
  actions: {
    startCalculate: ({commit}) => {
        commit('setCalculate', true)
    },
    finishCalculate: ({commit}) => {
        commit('setCalculate', false)
    }
  },
  modules: {
    order,
    project,
    prompt,
    talent,
    tag,
    user
  },
  strict: debug
})


//////////////////
// WEBPACK FOOTER
// ./prompts/store/index.js
// module id = null
// module chunks = 